export async function ensureLegacyCatalogLoaded(): Promise<void> {
  if (window.APP_SONGS && window.APP_UNITS) return;
  await new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "/legacy/data.js";
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Unable to load the legacy catalog."));
    document.head.append(script);
  });
  if (!window.APP_SONGS || !window.APP_UNITS) throw new Error("Legacy catalog loaded without expected globals.");
}
